import { render, staticRenderFns } from "./GroupsGrid.vue?vue&type=template&id=4031b37d&scoped=true"
import script from "./GroupsGrid.vue?vue&type=script&lang=js"
export * from "./GroupsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4031b37d",
  null
  
)

export default component.exports